// @ts-nocheck

import { ExternalLinkActionTypes, type ExternalLinkActionType } from '../types/actions/externallink';

export type ExternalLinkOptions = {
  inNewTab?: boolean;
  delay?: number;
  external?: boolean;
  auth?: boolean;
};
type ExternalLinkOpenAction = {
  type: ExternalLinkActionType;
  payload: {
    url: string;
  };
};
export type ExternalLinkOpenType = (type: MenuKeyType, key?: string | number | null) => ExternalLinkOpenAction;

export const externalLinkOpen = (url: string, options?: ExternalLinkOptions): ExternalLinkOpenAction => ({
  type: ExternalLinkActionTypes.OPEN,
  payload: {
    url,
    options,
  },
});

export default {
  externalLinkOpen,
};
